/* ============================================================
   CARTRI - Patrones tomados de la auditoria de HSN
   1. Aviso de promocion / ahorro del pack encima del boton de compra
      (metacampo custom.promo_ficha)
   2. Hora de corte de envio con cuenta atras real, debajo del boton
   Modulo aparte para poder quitarlo sin tocar el resto de la campana.
   ============================================================ */
(function () {
  'use strict';

  var CFG = window.LIQ || {};
  if (!CFG.enabled) return;
  var S = CFG.strings || {};

  function buyForm() {
    return document.querySelector('product-form') || document.querySelector('.product-form');
  }

  /* ---------- 1. Aviso de promocion sobre el boton ---------- */
  function initPromo() {
    var p = CFG.product;
    if (!p || !p.promo) return;
    if (document.querySelector('.liq-promo')) return;
    var form = buyForm();
    if (!form || !form.parentNode) return;

    var el = document.createElement('div');
    el.className = 'liq-promo';
    el.innerHTML = '<span aria-hidden="true">★</span><span></span>';
    el.lastChild.textContent = p.promo;
    form.parentNode.insertBefore(el, form);
  }

  /* ---------- 2. Hora de corte de envio ---------- */
  function madridNow() {
    try {
      var parts = new Intl.DateTimeFormat('en-GB', {
        timeZone: 'Europe/Madrid',
        weekday: 'short', hour: '2-digit', minute: '2-digit', second: '2-digit', hour12: false
      }).formatToParts(new Date());
      var o = {};
      parts.forEach(function (x) { o[x.type] = x.value; });
      return {
        weekday: o.weekday,
        h: parseInt(o.hour, 10),
        m: parseInt(o.minute, 10),
        s: parseInt(o.second, 10)
      };
    } catch (e) {
      var d = new Date();
      return { weekday: ['Sun','Mon','Tue','Wed','Thu','Fri','Sat'][d.getDay()], h: d.getHours(), m: d.getMinutes(), s: d.getSeconds() };
    }
  }

  function initCutoff() {
    if (!CFG.product) return;
    if (document.querySelector('.liq-cutoff')) return;
    var form = buyForm();
    if (!form || !form.parentNode) return;

    var cutoff = typeof CFG.cutoffHour === 'number' ? CFG.cutoffHour : 16;
    var el = document.createElement('p');
    el.className = 'liq-cutoff';
    el.innerHTML = '<span aria-hidden="true">🚚</span><span></span>';
    var txt = el.lastChild;
    form.parentNode.insertBefore(el, form.nextSibling);

    (function tick() {
      var n = madridNow();
      var laborable = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri'].indexOf(n.weekday) > -1;
      var secsLeft = ((cutoff - n.h) * 3600) - (n.m * 60) - n.s;

      if (laborable && secsLeft > 0) {
        var h = Math.floor(secsLeft / 3600);
        var m = Math.floor((secsLeft % 3600) / 60);
        var left = h > 0 ? h + ' h ' + m + ' min' : m + ' min';
        txt.innerHTML = (S.cutoffToday || 'Pidelo en las proximas <b>{{left}}</b> y sale hoy mismo')
          .replace('{{left}}', left);
      } else {
        txt.innerHTML = S.cutoffNext || 'Los pedidos de hoy salen el proximo dia habil';
      }
      setTimeout(tick, 30000);
    })();
  }

  function boot() {
    initPromo();
    initCutoff();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
